export class BackupZeroEtlCatalogConfiguration {
    'awsGlue';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsGlue",
            "baseName": "awsGlue",
            "type": "BackupZeroEtlAwsGlueCatalogConfiguration",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlCatalogConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
